import {useEnvironment} from '@wix/yoshi-flow-editor'
import React from 'react'
import {Divider} from 'wix-ui-tpa/cssVars'
import {classes} from './filter-container.st.css'

export const FilterContainer: React.FC = ({children}) => {
  const {isMobile} = useEnvironment()

  return (
    <div className={isMobile ? classes.container : classes.desktopContainer}>
      {children}
      {isMobile ? <Divider className={classes.divider} /> : null}
    </div>
  )
}
